<script setup>
const props = defineProps({
  type: {
    type: String,
    default: '',
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
})
const emits = defineEmits(['update:modelValue'])
const direction = ref(0)
const directionRaw = {
  '0': -1,
  '1': 0,
  '-1': 1,
}
function handleSort() {
  direction.value = directionRaw[direction.value]
  emits('update:modelValue', [props.type, direction.value])
}

watch(() => props.modelValue, ([type]) => {
  if (type !== props.type)
    direction.value = 0
})
</script>

<template>
  <div class="flex items-center" @click="handleSort">
    <span><slot /></span>
    <svg class="shrink-0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.44073 12.5229C8.20318 12.7801 7.79682 12.7801 7.55927 12.5229L5.46625 10.2571C5.11126 9.87284 5.38382 9.25 5.90698 9.25L10.093 9.25C10.6162 9.25 10.8887 9.87284 10.5338 10.2571L8.44073 12.5229Z" :fill="direction === -1 && modelValue[0] === type ? 'var(--textTextPrimary)' : 'var(--t2)'" />
      <path d="M7.55927 3.47711C7.79682 3.21995 8.20318 3.21995 8.44073 3.47711L10.5338 5.74287C10.8887 6.12716 10.6162 6.75 10.093 6.75L5.90698 6.75C5.38382 6.75 5.11126 6.12716 5.46625 5.74287L7.55927 3.47711Z" :fill="direction === 1 && modelValue[0] === type ? 'var(--textTextPrimary)' : 'var(--t2)'" />
    </svg>
  </div>
</template>
